var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 1] = "INFO";
    LogLevel[LogLevel["WARNING"] = 2] = "WARNING";
    LogLevel[LogLevel["ERROR"] = 3] = "ERROR";
})(LogLevel || (LogLevel = {}));
class Logger {
    constructor(name) {
        this.logLevel = LogLevel.INFO;
        this.name = name;
        // Keep track of the logger instances to update them from global
        // logging methods.
        instances.push(this);
    }
    getLogLevel() {
        return this.logLevel;
    }
    setLogLevel(logLevel) {
        if (typeof logLevel === 'string') {
            this.logLevel = logLevelStringConverter[logLevel];
            return;
        }
        this.logLevel = logLevel;
    }
    debug(...args) {
        this.log(LogLevel.DEBUG, ...args);
    }
    info(...args) {
        this.log(LogLevel.INFO, ...args);
    }
    warning(...args) {
        this.log(LogLevel.WARNING, ...args);
    }
    error(...args) {
        this.log(LogLevel.ERROR, ...args);
    }
    log(logLevel, ...args) {
        if (logLevel < this.logLevel)
            return;
        const now = new Date().toISOString();
        const method = consoleMethodConverter[logLevel];
        const format = this.logLevel >= LogLevel.INFO
            ? `[${now}] [${this.name}]`
            : `[${now}] [${this.name}] [${logLevelToStringConverter[logLevel]}]`;
        // eslint-disable-next-line no-console
        console[method](format, ...args);
    }
}
function setLogLevel(logLevel) {
    instances.forEach((instance) => instance.setLogLevel(logLevel));
}
/**
 * A container for all logger instances.
 */
const instances = [];
const logLevelStringConverter = {
    debug: LogLevel.DEBUG,
    info: LogLevel.INFO,
    warning: LogLevel.WARNING,
    error: LogLevel.ERROR,
};
const logLevelToStringConverter = {
    [LogLevel.DEBUG]: 'debug',
    [LogLevel.INFO]: 'info',
    [LogLevel.WARNING]: 'warning',
    [LogLevel.ERROR]: 'error',
};
const consoleMethodConverter = {
    [LogLevel.DEBUG]: 'log',
    [LogLevel.INFO]: 'info',
    [LogLevel.WARNING]: 'warn',
    [LogLevel.ERROR]: 'error',
};

export { LogLevel, Logger, setLogLevel };
//# sourceMappingURL=index.js.map
